export default __webpack_public_path__ + "static/question-03f184568e80211461656e4018966c79.png";